import TypingIndicator from "./TypingIndicator";
import MarkdownStream from "../markdown/MarkdownStream";

interface Props {
  text?: string;
  loading?: boolean;
}

const TypingText = (props: Props) => {
  return (
    <div>
      {props.text ? (
        <MarkdownStream markdownText={props.text} loading={props.loading} />
      ) : (
        props.loading && <TypingIndicator />
      )}
    </div>
  );
};

export default TypingText;
